import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {TextMessage} from '../model/email/TextMessage';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {Message} from '../model/microsite/message';

@JsonConverter
export class MessageConverter implements JsonCustomConvert<Message> {

    deserialize(json: any): Message {

        // const msgArr = new Array<TextMessage>();
        return Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json,Message);
        /*const temp:TSMap<string,string>= new TSMap();
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;*/
    }

    serialize(data: Message): any {
        return JSON.stringify(data);
    }
}
